module.exports = __webpack_public_path__ + "img/read-aloud-white.923447b1.svg";